import { authRoles } from 'app/auth';
import SuspicionEditForm from './editform/SuspicionEditForm';
import SuspicionTable from './table/SuspicionTable';

export default [
	{
		path: '/suspicion/edit/:id',
		component: SuspicionEditForm,
		auth: authRoles.userAccount
	},
	{
		path: '/suspicion/:sessionNameParam?',
		component: SuspicionTable,
		auth: authRoles.userAccount
	}
];
